import state from './moduleUserNotificationState'
import actions from './moduleUserNotificationActions'
import getters from './moduleUserNotificationGetters'
import mutations from './moduleUserNotificationMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
